export default __webpack_public_path__ + "static/media/icon_6_1.a6f240da.svg";